var actions = document.getElementById('js-actions');

//Open contact option dropdown
if (actions) {
    actions.addEventListener('click', function () {
        this.classList.toggle('open');
    });
}

//Close contact option dropdown when click next to it
document.onclick = function (e) {
    if (e.target != actions && e.target.parentNode != actions) {
        actions.classList.remove('open');
    }
};

//Set contact bar fixed when reaches to of the screen
var contactBar = document.querySelector('.block_hero_vacancy .recruiter');
var contactBarSmall = document.querySelector('.block_hero_vacancy .sticky-small');
var sticky = contactBar.offsetTop + contactBar.offsetHeight + 48;

// Only set sticky for xlarge and bigger
if (window.innerWidth >= 1024) {
    window.onscroll = function () {
        fixedContactBar();
    };

    function fixedContactBar() {
        if (window.pageYOffset > sticky) {
            contactBar.classList.add('is-sticky');
        } else {
            contactBar.classList.remove('is-sticky');
        }
    }
}

// Only set sticky for smaller then xlarge
if (window.innerWidth <= 1024) {
    window.onscroll = function () {
        fixedContactBarSmall();
    };

    function fixedContactBarSmall() {
        if (window.pageYOffset > sticky) {
            contactBarSmall.classList.add('show');
        } else {
            contactBarSmall.classList.remove('show');
        }
    }
}

import {setCookie} from '/src/js/custom/cookies';

let pageId = document.querySelectorAll('.js-cookie-id');

pageId.forEach(function (el) {
    el.addEventListener('click', function () {
        setCookie('vacancy_apply', el.dataset.id, 1);
    });
});
